import $ from "../../../components/jquery";
import UIkit from "uikit";
import Toast from "../../../components/toast";

export interface ReajusteIndiceAjustesConfig {
    listSelector: string;
    emptySelector: string;
    addButtonSelector: string;
    actionButtonSelector: string;
    modalSelector: string;
    formSelector: string;
    modalTitleSelector: string;
    globalName: string;
    onChange?: () => void;
    blockedMessage?: string;
}

export function criarGerenciadorAjustesIndice(config: ReajusteIndiceAjustesConfig) {
    return new ReajusteIndiceAjustes(config);
}

class ReajusteIndiceAjustes {
    private sequencial = 0;
    private bloqueados = false;

    constructor(private readonly config: ReajusteIndiceAjustesConfig) {
    }

    abrirModal(id?: number) {
        if (this.bloqueados) {
            Toast.error(this.config.blockedMessage || "Índices negativos não permitem descontos ou acréscimos.");
            return;
        }

        const form = $(this.config.formSelector);
        form.trigger("reset");
        form.find('[name="AjusteId"]').val("");

        if (id) {
            const row = $(`[data-ajuste-id="${id}"]`);
            form.find('[name="AjusteId"]').val(String(id));
            form.find('[name="TipoAjuste"]').val(String(row.attr("data-tipo-ajuste") || ""));
            form.find('[name="Percentual"]').val(String(row.attr("data-percentual") || ""));
            form.find('[name="Descricao"]').val(String(row.attr("data-descricao") || ""));
            $(this.config.modalTitleSelector).text("Editar ajuste");
        } else {
            $(this.config.modalTitleSelector).text("Adicionar ajuste");
        }

        UIkit.modal(this.config.modalSelector, { stack: true }).show();
    }

    salvarAjuste() {
        const form = $(this.config.formSelector);
        const idAtual = Number(form.find('[name="AjusteId"]').val() || 0);
        const tipoAjuste = Number(form.find('[name="TipoAjuste"]').val() || 0);
        const percentual = Number(form.find('[name="Percentual"]').val() || 0);
        const descricao = String(form.find('[name="Descricao"]').val() || "").trim();

        if (!tipoAjuste || (tipoAjuste !== 1 && tipoAjuste !== 2)) {
            Toast.error("Selecione o tipo do ajuste.");
            return;
        }

        if (!Number.isFinite(percentual) || percentual <= 0) {
            Toast.error("Informe um percentual maior que zero.");
            return;
        }

        if (!descricao) {
            Toast.error("Informe a descrição do ajuste.");
            return;
        }

        const id = idAtual || this.novoIdAjuste();
        const html = this.montarLinhaAjuste(id, tipoAjuste, percentual, descricao);
        const rowAtual = $(`[data-ajuste-id="${id}"]`);

        if (rowAtual.length) {
            rowAtual.replaceWith(html);
        } else {
            $(this.config.listSelector).append(html);
        }

        this.atualizarEstado();
        UIkit.modal(this.config.modalSelector).hide();
        this.config.onChange?.();
    }

    removerAjuste(id: number) {
        $(`[data-ajuste-id="${id}"]`).remove();
        this.atualizarEstado();
        this.config.onChange?.();
    }

    atualizarEstado() {
        const list = $(this.config.listSelector);
        list.find("tr").each((index, element) => this.atualizarInputsAjuste($(element), index));
        $(this.config.emptySelector).toggleClass("uk-hidden", list.children().length > 0);
        $(this.config.actionButtonSelector).prop("disabled", this.bloqueados);
        UIkit.update(list.get(0));
    }

    atualizarBloqueio(bloquear: boolean) {
        this.bloqueados = bloquear;
        $(this.config.addButtonSelector)
            .prop("disabled", bloquear)
            .attr("uk-tooltip", bloquear ? (this.config.blockedMessage || "Índices negativos não permitem descontos ou acréscimos.") : "Adicionar ajuste");
        $(this.config.actionButtonSelector).prop("disabled", bloquear);
    }

    private novoIdAjuste() {
        this.sequencial += 1;
        return new Date().getTime() + this.sequencial;
    }

    private montarLinhaAjuste(id: number, tipoAjuste: number, percentual: number, descricao: string) {
        const tipoDescricao = tipoAjuste === 1 ? "Desconto" : "Acréscimo";
        const tipoLabel = tipoAjuste === 1 ? "uk-label-warning" : "uk-label-success";
        const descricaoSegura = escapeHtml(descricao);

        return `
            <tr data-ajuste-id="${id}" data-tipo-ajuste="${tipoAjuste}" data-percentual="${percentual}" data-descricao="${descricaoSegura}">
                <td>
                    <span class="uk-label ${tipoLabel}">${tipoDescricao}</span>
                </td>
                <td>${percentual.toLocaleString("pt-BR", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}%</td>
                <td>${descricaoSegura}</td>
                <td class="uk-text-center">
                    <button class="uk-icon-button ${this.config.actionButtonSelector.replace(".", "")}" type="button" uk-tooltip="Editar ajuste" onclick="Thor.${this.config.globalName}.abrirModalAjuste(${id}); return false;" uk-icon="pencil"></button>
                    <button class="uk-icon-button uk-color-danger ${this.config.actionButtonSelector.replace(".", "")}" type="button" uk-tooltip="Remover ajuste" onclick="Thor.${this.config.globalName}.removerAjuste(${id}); return false;" uk-icon="close"></button>
                </td>
            </tr>`;
    }

    private atualizarInputsAjuste(row: JQuery, index: number) {
        const id = row.attr("data-ajuste-id");
        const tipoAjuste = row.attr("data-tipo-ajuste");
        const percentual = row.attr("data-percentual");
        const descricao = row.attr("data-descricao");

        row.find("input[type='hidden']").remove();
        row.find("td").first().append(`
            <input type="hidden" name="Ajustes.Index" value="${id}" />
            <input type="hidden" name="Ajustes[${id}].TipoAjuste" value="${tipoAjuste}" />
            <input type="hidden" name="Ajustes[${id}].Percentual" value="${percentual}" />
            <input type="hidden" name="Ajustes[${id}].Descricao" value="${escapeHtml(descricao || "")}" />
            <input type="hidden" name="Ajustes[${id}].Ordem" value="${index + 1}" />
        `);
    }
}

function escapeHtml(value: string) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}
